import "../Scss/styles.scss";

import { ShowMediaQueryDev } from "./utils/show-media-query-dev";
import { OnWindowResize } from "./utils/on-window-resize";
import { MainDropDownMenu } from "./components/accessible-menu";
import { HeaderSearchbar } from "./components/header-searchbar";
import { ReplaceSearchPlaceholder } from "./components/replace-search-placeholder";
import { FooterMobileMenu } from "./components/footer-mobile-menu";
import { GetInTouchSocials } from "./components/get-in-touch-socials";
import { ComparatorTable } from "./components/comparator-table";
import { ComparatorViewSwitch } from "./components/comparator-view-switch";
import { LanguageSelect } from "./components/language-select";
import { PumpPage } from "./components/pump-page";
import { FilteredMap } from "./components/filtered-map";
import { ScrollNav } from "./components/scroll-nav";
import { RequestConsultButton } from "./components/request-consult-button";
import { HlsVideo } from "./components/hls-video";
import { VimeoConsent } from "./components/vimeo-consent";

class VerderliquidsApp {
    constructor() {
        document.addEventListener("readystatechange", function () {
            if (document.readyState === "complete") {
                new ShowMediaQueryDev();
                new OnWindowResize();
                new MainDropDownMenu();
                new HeaderSearchbar();
                new ReplaceSearchPlaceholder();
                new FooterMobileMenu();
                new GetInTouchSocials();
                new ComparatorTable();
                new ComparatorViewSwitch();
                new LanguageSelect();
                new PumpPage();
                new FilteredMap();
                new ScrollNav();
                new RequestConsultButton();
                new HlsVideo();
                new VimeoConsent();
            }
        });
    }
}

window["VerderliquidsApp"] = new VerderliquidsApp();
